import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function QRCodeBlock() {
  const { language } = useLanguage();
  const t = CONTENT[language].contact;

  return (
    <Link to="/contact" className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 inline-block text-center hover:shadow-md transition-all group cursor-pointer block">
      <div className="bg-gray-900 w-32 h-32 mx-auto mb-2 flex items-center justify-center text-white group-hover:scale-105 transition-transform">
        {/* Simple QR Code Placeholder SVG */}
        <svg viewBox="0 0 100 100" className="w-full h-full" fill="white">
          <rect x="10" y="10" width="30" height="30" />
          <rect x="60" y="10" width="30" height="30" />
          <rect x="10" y="60" width="30" height="30" />
          <rect x="50" y="50" width="10" height="10" />
          <rect x="70" y="50" width="10" height="10" />
          <rect x="50" y="70" width="10" height="10" />
          <rect x="70" y="70" width="10" height="10" />
          <rect x="60" y="60" width="10" height="10" />
        </svg>
      </div>
      <p className="text-xs font-bold text-gray-600 uppercase tracking-wide group-hover:text-suncoast-primary transition-colors">{t.scanQr}</p>
    </Link>
  );
}